import axios from 'axios'
import { AJOUTER_BANQUE, LISTE_BANQUE, MODIFIER_BANQUE, MODIFIER_ETAT_BANQUE, SUPPRIMER_BANQUE,} from '../../api/apiRoute'

export const addBanque = async (data) => {
    return axios.post(AJOUTER_BANQUE, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const updateBanque = async (data) => {
    return axios.post(MODIFIER_BANQUE, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const getListeBanque = async () => {
    return axios.get(LISTE_BANQUE).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const deleteBanque = async (data) => {
    return axios.post(SUPPRIMER_BANQUE, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}


export const updateEtatBanque = async (data) => {
    return axios.post(MODIFIER_ETAT_BANQUE, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}